module.exports = __webpack_public_path__ + "static/media/7.c876ce61.jpg";